import type { InvestigationBill } from './types';

export const InvestigationBillAllRefundList = ({ row }: { row: InvestigationBill }) => (
  <>
    <header className="investigation-bill-detail-banner">
      <div className="investigation-bill-detail-banner-row"><span>All Refund — {row.patientSnapshot.name}</span></div>
      <p>UHID {row.patientSnapshot.uhid ?? '-'} · 0 refunds</p>
    </header>
    <section className="investigation-bill-detail-subsection">
      <div className="table-scroll">
        <table className="investigation-bill-detail-payment-table">
          <thead><tr><th>#</th><th>Bill No</th><th>Date</th><th>Mode</th><th>Amount</th><th>Reason</th></tr></thead>
          <tbody><tr><td className="investigation-bill-detail-empty" colSpan={6}>No refunds have been recorded. Refund tracking isn't implemented in the billing system yet.</td></tr></tbody>
        </table>
      </div>
    </section>
  </>
);
